import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_LOCATION,
} from '../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { LOCATIONS_EDIT } from '../../../../constants/LocationConst';
import { allLocationsSelector } from '../../../property/propertySlice';

const LocationView = (props) => {
  const { location, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const [selectedLocation, setSelectedLocation] = useState();
  const originalLocation = useSelector(allLocationsSelector);

  useEffect(() => {
    let locationObj = {
      ...originalLocation.find((obj) => obj.id === location.id),
    };
    setSelectedLocation(locationObj);
  }, [hotelId, originalLocation]);

  const onClickEdit = (event) => {
    toggleDrawer(LOCATIONS_EDIT, true, selectedLocation);
  };

  const renderScreen = () => {
    return (
      <>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-6'>
            <div className='details-label'>Location Name</div>
            <div className='details-value'>{selectedLocation.name}</div>
          </div>
          <div className='col-md-6'>
            <div className='details-label'>Location Type</div>
            <div className='details-value'>
              {selectedLocation.type === 'INTERNAL' ? 'Internal' : 'External'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>{selectedLocation.description}</div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {selectedLocation && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedLocation.name}
          createdUserId={selectedLocation.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_LOCATION] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
        />
      )}
    </>
  );
};

export default LocationView;
